import React from 'react';
import '../styles/Card.css';

export const Card = ({ isDarkMode, images = [], title, description, buttonLabel, onClick, badges = []  }) => {
  return (
    <div className={`card ${isDarkMode ? 'card-dark' : 'card-light'}`}>
      <div className="card-carousel-hover">
        {images.map((img, idx) => (
          <img key={idx} className="carousel-image" src={img} alt={`${title}-${idx}`} />
        ))}
      </div>
      <div className="card-content">
        <h2 className="card-title">{title}</h2>
        <p className="card-description">{description}</p>

        {/* Badge section */}
        {badges.length > 0 && (
          <div className="card-badges">
            {badges.map((tech, idx) => (
              <span key={idx} className="badge">
                {tech}
              </span>
            ))}
          </div>
        )}

        {buttonLabel && (
          <button className="card-button" onClick={onClick}>
            {buttonLabel}
          </button>
        )}
      </div>
    </div>
  );
};
